import firebase from 'firebase/app';

import { firestore } from '../../../firebase/firebase';
import { Offer } from '../../../models/offers.model';
import { WantedListing } from '../../../models/wantedListings.model';

export const checkForMatchingWantedListings = async (_offer: Offer, tenantUid: string): Promise<WantedListing[]> => {
  try {
    // Pobierz WSZYSTKIE aktywne wanted listings dla najemcy
    const snapshot = await firestore
      .collection('wantedListings')
      .where('uid', '==', tenantUid)
      .where('status', '==', 'active')
      .get();

    const wantedListings = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    })) as WantedListing[];

    // Zwróć wszystkie aktywne ogłoszenia bez filtrowania
    return wantedListings;
  } catch (error) {
    console.error('Error checking for matching wanted listings:', error);
    return [];
  }
};

export const associateOfferWithWantedListings = async (
  offerId: string,
  selectedListingIds: string[],
  tenantUid: string
): Promise<void> => {
  if (selectedListingIds.length === 0) return;

  const batch = firestore.batch();

  for (const listingId of selectedListingIds) {
    const listingRef = firestore.collection('wantedListings').doc(listingId);

    // Dodaj ofertę do submittedOffers
    batch.update(listingRef, {
      submittedOffers: firebase.firestore.FieldValue.arrayUnion({
        offerId,
        submittedAt: new Date().toISOString(), // Używamy ISO string zamiast serverTimestamp
        submittedBy: tenantUid,
        isMatched: true, // oznacz jako dopasowane przez najemcę
      }),
      status: 'matched', // zmień status na matched
      matchedAt: firebase.firestore.FieldValue.serverTimestamp(),
    });
  }

  await batch.commit();
};
